import React from 'react';
import EnergyAudit from '../components/energyAudit/EnergyAudit';

const EnergyAuditPage = () => {
  return (
    <div>
      <EnergyAudit />
    </div>
  );
};

export default EnergyAuditPage;
